"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Subtitle1: function() {
        return _Subtitle1.Subtitle1;
    },
    subtitle1ClassNames: function() {
        return _useSubtitle1Stylesstyles.subtitle1ClassNames;
    }
});
const _Subtitle1 = require("./Subtitle1");
const _useSubtitle1Stylesstyles = require("./useSubtitle1Styles.styles");
